import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "CarouselVertical"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M19.5 7.5V16.5C19.5 17.3284 18.8284 18 18 18H6C5.17157 18 4.5 17.3284 4.5 16.5V7.5C4.5 6.67157 5.17157 6 6 6H18C18.8284 6 19.5 6.67157 19.5 7.5ZM6 16.5H18V7.5H6V16.5ZM18 21V24H16.5V21H7.5V24H6V21C6 20.1716 6.67157 19.5 7.5 19.5H16.5C17.3284 19.5 18 20.1716 18 21ZM18 0V3C18 3.82843 17.3284 4.5 16.5 4.5H7.5C6.67157 4.5 6 3.82843 6 3V0H7.5V3H16.5V0H18Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/CarouselVertical.vue"]]);
